import { Icon } from "@iconify/react";
import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "../CSS/UnitCountOneAnim.css";
import Facebook from "../../Assets/Facebook.png";
import Google from "../../Assets/Google.png";
import WowReview from "../../Assets/WowReview.png";
import Tripadvisor from "../../Assets/Tripadvisor.png";
import { Link } from "react-router-dom";

const UnitCountOne = ({
  total_reviews,
  total_reviews_last,
  total_reviews_positive,
  total_reviews_positive_last,
  total_reviews_positive_new,
  total_reviews_positive_last_new,
  total_reviews_negative,
  total_reviews_negative_last,
  total_reviews_third_party,
  total_reviews_third_party_last,
  total_click_type,
  has_comparison,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [animationDirection, setAnimationDirection] =
    useState("slide-in-right");

  const settings = {
    dots: true,
    autoplay: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    cssEase: "ease-in-out",
    className: `sliding-container ${animationDirection}`,
    beforeChange: (oldIndex, newIndex) => {
      setCurrentIndex(newIndex); // Update the currentIndex state
    },
    appendDots: (dots) => (
      <div className="custom-dots">
        <ul>{dots}</ul>
      </div>
    ),
  };

  const toNum = (v) => {
    const n = parseInt(v);
    return isNaN(n) ? 0 : n;
  };

  // All time (click_type = 6) pe koi previous period nahi hota,
  // isliye arrow badge ki jagah sirf "All time" dikhta hai.
  const ChangeBadge = ({ diff }) => {
    if (!has_comparison) {
      return (
        <p className="fw-medium text-sm text-primary-light mt-12 mb-0 d-flex align-items-center gap-2">
          <span className="text-secondary-light">All time</span>
        </p>
      );
    }

    return (
      <p className="fw-medium text-sm text-primary-light mt-12 mb-0 d-flex align-items-center gap-2">
        {diff > 0 ? (
          <span className="d-inline-flex align-items-center gap-1 text-success-main">
            <Icon icon="bxs:up-arrow" className="text-xs" />
            {diff}
          </span>
        ) : (
          <span className="d-inline-flex align-items-center gap-1 text-danger-main">
            <Icon icon="bxs:down-arrow" className="text-xs" />
            {diff}
          </span>
        )}
        {"  "}Last {total_click_type}
      </p>
    );
  };

  return (
    <div
      className="row row-cols-xxl-4 row-cols-lg-3 row-cols-sm-2 row-cols-1 gy-4 sliderDashBoad mt-0"
      style={{ paddingRight: "0" }}
    >
      {/**--------------- Total Reviews (first card) -------- */}
      <div className="col">
        <Link
          to="/Reviews"
          className="card shadow-none border bg-gradient-start-1 h-100"
        >
          <div className="card-body d-flex flex-column justify-content-between p-20">
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
              <div>
                <p className="fw-medium text-primary-light mb-1">
                  Total Reviews
                </p>
                <h6 className="mb-0">{total_reviews}</h6>
              </div>
              <div className="w-50-px h-50-px bg-cyan rounded-circle d-flex justify-content-center align-items-center">
                <Icon
                  icon="gridicons:multiple-users"
                  className="text-white text-2xl mb-0"
                />
              </div>
            </div>

            <ChangeBadge
              diff={toNum(total_reviews) - toNum(total_reviews_last)}
            />
          </div>
        </Link>
      </div>

      {/**--------------- Positive Reviews (second card) -------- */}
      <div className="col padding991">
        <Link
          to="/Reviews"
          state={{ label: "positive" }}
          className="card shadow-none border bg-gradient-start-2 h-100"
        >
          <div className="card-body d-flex flex-column justify-content-between p-20">
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
              <div>
                <p className="fw-medium text-primary-light mb-1">Positive</p>
                <h6>{toNum(total_reviews_positive)}</h6>
              </div>
              <div className="w-50-px h-50-px bg-purple rounded-circle d-flex justify-content-center align-items-center">
                <Icon
                  icon="fa-solid:award"
                  className="text-white text-2xl mb-0"
                />
              </div>
            </div>

            <ChangeBadge
              diff={
                toNum(total_reviews_positive) +
                toNum(total_reviews_positive_new) -
                toNum(total_reviews_positive_last) -
                toNum(total_reviews_positive_last_new)
              }
            />
          </div>
        </Link>
      </div>

      {/**--------------- Negative Reviews (third card) -------- */}
      <div className="col padding00">
        <Link
          to="/Reviews"
          state={{ label: "negative" }}
          className="card shadow-none border bg-gradient-start-3 h-100"
        >
          <div className="card-body d-flex flex-column justify-content-between p-20">
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
              <div>
                <p className="fw-medium text-primary-light mb-1">Negative</p>
                <h6>{total_reviews_negative}</h6>
              </div>
              <div className="w-50-px h-50-px bg-info rounded-circle d-flex justify-content-center align-items-center">
                <Icon
                  icon="fluent:people-20-filled"
                  className="text-white text-2xl mb-0"
                />
              </div>
            </div>

            <ChangeBadge
              diff={
                toNum(total_reviews_negative) -
                toNum(total_reviews_negative_last)
              }
            />
          </div>
        </Link>
      </div>

      {/**--------------- Platform-wise slider (last card) -------- */}
      <div className="col padding991">
        <div className="card shadow-none border bg-gradient-start-4 fixed-card">
          <div
            className="card-body d-flex flex-column justify-content-between h-100 p-20 overflow-hidden"
            style={{ position: "relative" }}
          >
            {total_reviews_third_party &&
            total_reviews_third_party.length > 0 ? (
              <Slider {...settings}>
                {total_reviews_third_party.map((item, index) => (
                  <Link
                    to="/Reviews"
                    state={{ label: (item.platform || "").toLowerCase() }}
                    key={index}
                    className={`sliding-card ${
                      index === currentIndex ? "active" : ""
                    }`}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex justify-content-between gap-3">
                      <div>
                        <p
                          className="fw-medium text-primary-light mb-1"
                          style={{ fontSize: "15px" }}
                        >
                          {item.platform}
                        </p>
                        <p
                          className="mb-0 fw-medium"
                          style={{ fontSize: "12px" }}
                        >
                          Positive: <span>{item.positive_count}</span>
                        </p>
                        <p
                          className="mb-0 fw-medium"
                          style={{ fontSize: "12px" }}
                        >
                          Negative: <span>{item.negative_count}</span>
                        </p>
                      </div>
                      <div className="w-50-px h-50-px rounded-circle d-flex justify-content-center align-items-center">
                        {item.platform === "Facebook" && (
                          <img src={Facebook} alt="Facebook" title="Facebook" />
                        )}
                        {item.platform === "Google" && (
                          <img src={Google} alt="Google" title="Google" />
                        )}
                        {item.platform === "WowReview" && (
                          <img
                            src={WowReview}
                            alt="WowReview"
                            title="WowReview"
                          />
                        )}
                        {item.platform === "Tripadvisor" && (
                          <img
                            src={Tripadvisor}
                            alt="Tripadvisor"
                            title="Tripadvisor"
                          />
                        )}
                      </div>
                    </div>
                  </Link>
                ))}
              </Slider>
            ) : (
              <div className="d-flex flex-column justify-content-center align-items-center h-100">
                <p className="fw-medium text-primary-light mb-1">
                  No platform data
                </p>
                <p
                  className="mb-0 text-secondary-light"
                  style={{ fontSize: "12px" }}
                >
                  Connect a review platform to see the breakdown
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnitCountOne;
